import * as ContactListTypes from 'src/constants/contacts-list-types'

// The types that keep their members as list items. A dynamic list resolves from its
// filters and holds none, so the items-count endpoint reports 0 for one.
const ITEM_BACKED_TYPES = [
  ContactListTypes.STATIC,
  ContactListTypes.DYNAMIC_REMOTE_LIST
]

export const isItemBackedType = (type) => ITEM_BACKED_TYPES.includes(type)
